import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlayground: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlayground"><Path d="M17.2619 17.3154C17.2619 19.0742 15.8339 20.5 14.0723 20.5C12.3108 20.5 10.8828 19.0742 10.8828 17.3154C10.8828 15.5565 12.3108 14.1307 14.0723 14.1307C15.8339 14.1307 17.2619 15.5565 17.2619 17.3154Z" stroke="currentColor"/><Path d="M4.77907 6.84009L10.4217 11.5675L3.5 14.0829L4.77907 6.84009Z" stroke="currentColor"/><Path d="M14.3385 3.25L20.5002 4.89848L18.8492 11.0507L12.6875 9.4022L14.3385 3.25Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPlayground;
